import React from 'react';
import './SignIn.scss';
function SignIn() {
  window.location.href = process.env.REACT_APP_WISERNOTIFY_DOMAIN + 'login';
  return (
    <div>

    </div>
  );
}

export default SignIn;


// WEBPACK FOOTER //
// ./src/containers/SignIn/SignIn.js